import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["audience", "audienceNameComponent", "audienceComponentProps"];
import { useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { isShowToEveryone, findSavedAudienceFilter } from '../../utils/audience';
import { jsx as _jsx } from "react/jsx-runtime";
const VisitorsDescription = _ref => {
  let {
      audience,
      audienceNameComponent: SavedAudienceName,
      audienceComponentProps = {}
    } = _ref,
    textProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const savedAudienceFilter = useMemo(() => findSavedAudienceFilter(audience), [audience]);
  const hasAudienceTargetingFilters = useMemo(() => !isShowToEveryone(audience), [audience]);
  const [error, setIsError] = useState(false);
  if (savedAudienceFilter) {
    return SavedAudienceName && !error ? /*#__PURE__*/_jsx(SavedAudienceName, Object.assign({
      audienceId: savedAudienceFilter.values,
      onError: () => setIsError(true)
    }, audienceComponentProps)) : /*#__PURE__*/_jsx(Text, Object.assign({
      "data-test-id": "targeted-saved-audience-description"
    }, textProps, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "AudienceTargeting.display.targetedVisitors.savedAudienceFallback"
      })
    }));
  }
  return /*#__PURE__*/_jsx(Text, Object.assign({
    "data-test-id": "targeted-visitors-description"
  }, textProps, {
    children: hasAudienceTargetingFilters ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "AudienceTargeting.display.targetedVisitors.filteredVisitors"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "AudienceTargeting.display.targetedVisitors.allVisitors"
    })
  }));
};
export default VisitorsDescription;